import { styled, lighten } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";

export const Input = styled("input")({
  position: "absolute",
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  opacity: 0,
});

export const DragAndDrop = styled(Grid)(({ theme }) => ({
  minHeight: 50,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: `1px dashed ${lighten(theme.palette.text.secondary, 0.5)}`,
  padding: 5,

  "&:hover": {
    border: "1px dotted #793058",
    color: "#793058",
  },
}));

export const TextUpload = styled(Typography)({
  paddingInlineStart: 10,
});
